// extracted by mini-css-extract-plugin
export default {"container":"article_container__MQIqI","contentContainer":"article_contentContainer__arDoi","emptyBodyContainer":"article_emptyBodyContainer__jfBko"};